import React from "react";
import * as masterservice from "../../services/master/master-service";
import * as transAnalysisService from "../../services/kyc/trans-analysis-service";
import { Authorize } from "../../components/authorize";
import * as Loader from "../../common/common";
import DropDown from "../../components/form-controls/dropdown";
import { commonDownloadPdf } from "../../common/download-pdf";
import * as commonDownloadPdfService from "../../services/pdf/download_pdf_service";
import { withRouterProps } from "../../common/hocs";

class TransactionAnalysisForm extends Authorize {
  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.downloadPdf = this.downloadPdf.bind(this);
  }

  state = {
    clientId: this.props.clientId,
    userType: this.props.clientType,
    transAnalysisDetails: {
      division:
        this.props.clientType === "Customer" ? "Mandatory" : "Prohibited",
      gstSTAnalysisCode:
        this.props.clientType === "Customer" ? "Prohibited" : "Mandatory",
      services:
        this.props.clientType === "Customer" ? "Mandatory" : "Prohibited",
      custSupp: "Mandatory",
      vehicle: "Prohibited",
      misc: "Prohibited",
      depemp: "Prohibited",
      tallyVouch: "Prohibited",
      tds: this.props.clientType === "Customer" ? "Prohibited" : "Mandatory",
      uid: "Prohibited",
    },
    dropdownFields: [],
  };

  async downloadPdf(clientId) {
    let data = {
      clientId: clientId,
    };
    let {
      response,
      err,
    } = await commonDownloadPdfService.downloadTransactionAnalysis(data);
    if (err) {
    } else if (response.data) {
      commonDownloadPdf(response.data, "TransactionAnalysis_" + clientId);
    }
  }

  handleInputChange(e) {
    let target = e.target;
    let value = target.value;
    let name = target.name;

    this.setState({
      transAnalysisDetails: {
        ...this.state.transAnalysisDetails,
        [name]: value,
      },
    });
  }

  async onSubmit(v, e) {
    Loader.showLoader();
    if (!e) {
      e = v;
    }
    e.preventDefault();
    if (v && v === "prev") {
      this.props.router.navigate(
        "/kycs/" +
          this.state.clientId +
          "/" +
          this.state.userType +
          "/accountanalysis"
      );
    } else {
      let isSaved = false;
      let transAnalysisDetails = this.state.transAnalysisDetails;
      let userId = this.state.clientId;
      let data = { transAnalysisDetails, userId };
      let { response, err } = await transAnalysisService.saveTransAnalysis(
        data
      );
      Loader.hideLoader();
      if (err) {
        this.setState({
          error: err,
          msg: "",
        });
      } else if (response.data && response.data.err) {
        this.setState({
          error: response.data.err,
          msg: "",
        });
      } else {
        isSaved = true;
        this.setState({
          error: "",
          msg: response.data.msg,
        });
        if (isSaved) {
          if (v && v === "next") {
            if (this.state.userType === "Customer") {
              this.props.router.navigate(
                "/kycs/" +
                  this.state.clientId +
                  "/" +
                  this.state.userType +
                  "/analysiscustomer"
              );
            } else if (
              this.state.userType === "Supplier" ||
              this.state.userType === "CustomerSupplier"
            ) {
              this.props.router.navigate(
                "/kycs/" +
                  this.state.clientId +
                  "/" +
                  this.state.userType +
                  "/supplieranalysis"
              );
            }
          } else {
            this.getTransAnalysis();
          }
        }
      }
    }
  }

  async componentDidMount() {
    Loader.showLoader();
    this.getTransAnalysis();
    let response = await masterservice.getMastersByGroup("TransAnalysis");
    Loader.hideLoader();
    this.setState({
      dropdownFields: response && response.response && response.response.data,
    });
  }

  async getTransAnalysis() {
    Loader.showLoader();
    let transAnalysisData = await transAnalysisService.getTransAnalysis(
      this.state.clientId
    );
    Loader.hideLoader();
    if (
      transAnalysisData &&
      transAnalysisData.response &&
      transAnalysisData.response.data
    ) {
      this.setState({
        transAnalysisDetails: transAnalysisData.response.data,
      });
    } else {
      return;
    }
  }

  render() {
    const authorizationResult = super.render();
    if (authorizationResult) {
      return authorizationResult;
    }

    var { dropdownFields } = this.state;
    var {
      division,
      gstSTAnalysisCode,
      services,
      custSupp,
      vehicle,
      misc,
      depemp,
      tallyVouch,
      tds,
      uid,
    } = this.state.transAnalysisDetails;
    let dropdown = dropdownFields;
    return (
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-md-12">
            <button
              className="float-right btn btn-md btn-info"
              title="Download PDF"
              onClick={this.downloadPdf.bind(this, this.state.clientId)}
            >
              <i className="fa fa-download"></i> PDF{" "}
            </button>
          </div>

          <div className="col-md-12">
            {this.state.msg ? (
              <div className="row">
                <span className="msg-style-success">{this.state.msg}</span>
              </div>
            ) : null}
            <form onSubmit={this.onSubmit}>
              <div className="row">
                <div className="col-sm-4">
                  <DropDown
                    label="Division"
                    name="division"
                    required={false}
                    value={division || ""}
                    error=""
                    onChange={this.handleInputChange}
                    defaultItem={null}
                    list={dropdown}
                    valProp="name"
                    textProp="name"
                  />
                </div>
                <div className="col-sm-4">
                  <DropDown
                    label=" GST / ST Analysis Code"
                    name="gstSTAnalysisCode"
                    required={false}
                    value={gstSTAnalysisCode || ""}
                    error=""
                    onChange={this.handleInputChange}
                    defaultItem={null}
                    list={dropdown}
                    valProp="name"
                    textProp="name"
                  />
                </div>
                <div className="col-sm-4">
                  <DropDown
                    label="Services"
                    name="services"
                    required={false}
                    value={services || ""}
                    error=""
                    onChange={this.handleInputChange}
                    defaultItem={null}
                    list={dropdown}
                    valProp="name"
                    textProp="name"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <DropDown
                    label="Customer / Supplier"
                    name="custSupp"
                    required={false}
                    value={custSupp || ""}
                    error=""
                    onChange={this.handleInputChange}
                    defaultItem={null}
                    list={dropdown}
                    valProp="name"
                    textProp="name"
                  />
                </div>
                <div className="col-sm-4">
                  <DropDown
                    label="Vehicle"
                    name="vehicle"
                    required={false}
                    value={vehicle || ""}
                    error=""
                    onChange={this.handleInputChange}
                    defaultItem={null}
                    list={dropdown}
                    valProp="name"
                    textProp="name"
                  />
                </div>
                <div className="col-sm-4">
                  <DropDown
                    label="Miscellaneous"
                    name="misc"
                    required={false}
                    value={misc || ""}
                    error=""
                    onChange={this.handleInputChange}
                    defaultItem={null}
                    list={dropdown}
                    valProp="name"
                    textProp="name"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <DropDown
                    label="DEP/EMP"
                    name="depemp"
                    required={false}
                    value={depemp || ""}
                    error=""
                    onChange={this.handleInputChange}
                    defaultItem={null}
                    list={dropdown}
                    valProp="name"
                    textProp="name"
                  />
                </div>
                <div className="col-sm-4">
                  <DropDown
                    label="TALLY_VOUCH"
                    name="tallyVouch"
                    required={false}
                    value={tallyVouch || ""}
                    error=""
                    onChange={this.handleInputChange}
                    defaultItem={null}
                    list={dropdown}
                    valProp="name"
                    textProp="name"
                  />
                </div>
                <div className="col-sm-4">
                  <DropDown
                    label="TDS"
                    name="tds"
                    required={false}
                    value={tds || ""}
                    error=""
                    onChange={this.handleInputChange}
                    defaultItem={null}
                    list={dropdown}
                    valProp="name"
                    textProp="name"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <DropDown
                    label="UID"
                    name="uid"
                    required={false}
                    value={uid || ""}
                    error=""
                    onChange={this.handleInputChange}
                    defaultItem={null}
                    list={dropdown}
                    valProp="name"
                    textProp="name"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="float-right">
                    <button
                      className="btn btn-md btn-primary"
                      type="button"
                      onClick={this.onSubmit.bind(this, "prev")}
                    >
                      Previous
                    </button>
                    &nbsp;
                    <button
                      className="btn btn-md btn-success"
                      type="submit"
                      onClick={this.onSubmit}
                    >
                      Save
                    </button>
                    &nbsp;
                    <button
                      className="btn btn-md btn-warning"
                      type="button"
                      onClick={this.onSubmit.bind(this, "next")}
                    >
                      Save and Next
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

// Custom HOC to inject router props to use React Router v6 hooks in class components
export default withRouterProps(TransactionAnalysisForm);